import { render, staticRenderFns } from "./RiskAssessmentRow.vue?vue&type=template&id=5422573e"
import script from "./RiskAssessmentRow.vue?vue&type=script&lang=ts"
export * from "./RiskAssessmentRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports